var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search" }, [
    _c("div", { staticClass: "banxin" }, [
      _c("div", { staticClass: "head", staticStyle: { height: "10px" } }),
      _vm._v(" "),
      _c("div", { staticClass: "result" }, [
        _vm.searchVal == "商品" && _vm.noProduct == false
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "pro"
              },
              [_c("ProductList", { attrs: { productList: _vm.productList } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.searchVal == "商品" && _vm.noProduct == true
          ? _c("div", { staticClass: "empty" }, [
              _c("img", {
                attrs: {
                  src: require("../../../static/image/nosearch@2x.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "fs20 font-color-999" }, [
                _vm._v(
                  "\n          搜索不到您要找的商品呢换个词试试吧～\n        "
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div"),
        _vm._v(" "),
        _vm.searchVal == "店铺" && _vm.noShop == true && _vm.network == false
          ? _c("div", { staticClass: "empty" }, [
              _c("img", {
                attrs: {
                  src: require("../../../static/image/nosearch@2x.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "fs20 font-color-999" }, [
                _vm._v(
                  "\n          搜索不到您要找的店铺呢换个词试试吧～\n        "
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.network
          ? _c("div", { staticClass: "network" }, [
              _c("img", {
                attrs: {
                  src: require("../../../static/image/poornetwork@2x.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "fs20 font-color-999" }, [
                _vm._v("哎呀，网络开小差了～")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.searchVal == "店铺" && _vm.noShop == false
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading1,
                    expression: "loading1"
                  }
                ],
                staticClass: "store"
              },
              _vm._l(_vm.storeList, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "storeBox",
                    staticStyle: {
                      width: "48%",
                      margin: "10px 10px",
                      padding: "10px",
                      "background-color": "#ffffff"
                    }
                  },
                  [
                    _c("div", { staticClass: "top" }, [
                      item.shopLogo
                        ? _c("img", {
                            staticClass: "storeImg",
                            attrs: { src: item.shopLogo, alt: "" }
                          })
                        : _c("img", {
                            staticClass: "storeImg",
                            attrs: {
                              src: require("../../assets/images/logo.png"),
                              alt: ""
                            }
                          }),
                      _vm._v(" "),
                      _c("div", { staticClass: "storeDesc" }, [
                        _c("p", { staticClass: "storeName" }, [
                          _vm._v(_vm._s(item.shopName))
                        ]),
                        _vm._v(" "),
                        _c("img", {
                          staticStyle: { width: "80px", height: "27px" },
                          attrs: {
                            src: require("../../assets/images/renzheng.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("img", {
                          staticStyle: {
                            width: "19px",
                            height: "24px",
                            "margin-left": "20px"
                          },
                          attrs: {
                            src: require("../../assets/images/qiye.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticStyle: { "margin-left": "5px" } }, [
                          _vm._v("一年")
                        ]),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "icon-positioning",
                          staticStyle: { "margin-left": "20px" }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "storeSite" }, [
                          _vm._v("所在地：" + _vm._s(item.shopAdress))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticStyle: { "margin-left": "10px" } }, [
                          _vm._v(" 主营产品：食品百货")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "enter",
                          on: {
                            click: function($event) {
                              return _vm.toStore(item.shopId)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "jindian" }, [
                            _vm._v("进店>")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    item.skus.length
                      ? _c(
                          "div",
                          {
                            staticClass: "content",
                            staticStyle: { background: "none !important" }
                          },
                          _vm._l(item.skus, function(items, indexs) {
                            return indexs < 4
                              ? _c(
                                  "div",
                                  {
                                    key: indexs,
                                    staticClass: "productBox",
                                    on: {
                                      click: function($event) {
                                        return _vm.toProductDetail(
                                          item.shopId,
                                          items
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: { src: items.image, alt: "" }
                                    })
                                  ]
                                )
                              : _vm._e()
                          }),
                          0
                        )
                      : _vm._e()
                  ]
                )
              }),
              0
            )
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {},
      [
        _vm.productList.length > 0 || _vm.storeList.length > 0
          ? _c("el-pagination", {
              attrs: {
                "current-page": _vm.page,
                "page-size": _vm.pageSize,
                background: "",
                layout: "prev, pager, next",
                total: _vm.total
              },
              on: { "current-change": _vm.handleCurrentChange }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-a0fd5576", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-a0fd5576","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/search/index.vue
// module id = null
// module chunks = 